import { BrowserView, MobileView, isBrowser, isMobile as isMobileBrowser } from "react-device-detect";

import React, { useState, createContext, useEffect, Component } from "react";
import Requester from "shared/Requester";
import FileRequester from "shared/FileRequester";
import NiceModal from "@ebay/nice-modal-react";
import AuthProvider from "providers/AuthProvider";
import BrowserEventProvider from "providers/BrowserEventProvider";
import RootRouter from "router/RootRouter";
import { ToastContainer } from "react-toastify";
import style from "./App.module.css";
import { useSelector, useDispatch } from "react-redux";
import Loading from "modals/base/Loading";
import BffRequester from "shared/BffRequester";
import VideoRequester from "shared/VideoRequester";

export const requester = new Requester();
export const fileRequester = new FileRequester();
export const bffRequester = new BffRequester();
export const videoRequester = new VideoRequester();

function App() {
  // const { isLoading } = useSelector((state) => ({
  //     isLoading: state.history.isLoading
  // }));

  useEffect(() => {
    const disableScrollRestoration = () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    };

    disableScrollRestoration();

    return () => {
      window.removeEventListener('beforeinstallprompt', () => { });
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  return (
    <BrowserEventProvider>
      <div className={style.toast}>
        <ToastContainer />
      </div>
      {/* <Loading isLoading={isLoading} /> */}
      <NiceModal.Provider>
        <AuthProvider>
          <RootRouter />
        </AuthProvider>
      </NiceModal.Provider>
    </BrowserEventProvider>
  );
}

export default App;